import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';
import { FRAGMENT_CONTENT_VALIDATION } from 'src/graphql/schema';

const MUTATION = gql`
  mutation UpdateVariationContentValidation($id: ID!) {
    updateVariationContentValidation(id: $id) {
      id
      contentSafety {
        ...ContentValidation
      }
    }
  }
  ${FRAGMENT_CONTENT_VALIDATION}
`;

const prepareContext = (variationId) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"UpdateVariationContentValidation" request [variationId: ${variationId}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const updateVariationContentValidation = (id) => {
  return apolloClient
    .mutate({
      mutation: MUTATION,
      variables: { id },
      context: prepareContext(id),
    })
    .then(({ data }) => getSingleProp(data));
};
